export const views = {
  CAMPAIGNS_VIEW: 'campaignsView',
  MY_CAMPAIGN_VIEW: 'myCampaignView',
  USER_CAMPAIGN_VIEW: 'userCampaignView',
  ORGANIZATION_CAMPAIGN_VIEW: 'organizationCampaignView',
  TEAMS_VIEW: 'teamsView',
  TEAM_INFO_VIEW: 'teamInfoView',
  MY_DONATIONS_VIEW: 'myDonationsView',
  USER_INFO_VIEW: 'userInfoView',
  CAMPAIGN_INFO_VIEW: 'campaignInfoView',
  TEAMS_LIST_VIEW: 'teamsListView',
  ADMIN_VIEW:"adminView",
  MAIN_VIEW:"mainView"
}

